// extracted by mini-css-extract-plugin
export default {"tabGroup":"_7AAhnYORGbLCyJUTiP5hbb"};